import { CxEvent } from '@spartacus/core'

export class AuthenticationEvent extends CxEvent {

  static readonly type = 'authentication'

  event = 'authentication'

  userID: string = ''

  constructor (userId: string) {
    super()
    this.userID = userId
  }
}
